import { useState, createContext, useEffect, useContext } from 'react';

//This whole class can be replaced with useMediaQuery hook from MUI

export const HandleScreenSizeContext = createContext();

export const ScreenType = {
  SMALL: 'SMALL',
  LARGE: 'LARGE',
};

export const ScreenSizeProvider = ({ children }) => {
  const [screenType, setScreenType] = useState(
    window.innerWidth < 768 ? ScreenType.SMALL : ScreenType.LARGE,
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenType(
        window.innerWidth < 768 ? ScreenType.SMALL : ScreenType.LARGE,
      );
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <HandleScreenSizeContext.Provider value={{ screenType }}>
      {children}
    </HandleScreenSizeContext.Provider>
  );
};

export const useHandleScreenSize = () => {
  return useContext(HandleScreenSizeContext);
};
